// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Nvce","productName":"Table_productName__1Zonq"};